<template>
  <div class="results-container">
    <div class="student-header">
      <div class="header-background"></div>
      <div class="header-content">
        <div class="student-badge">
          <span class="badge-text">ASSESSMENT RESULT</span>
          <div class="badge-decoration"></div>
        </div>
        
        <div class="student-profile">
          <div class="avatar-container">
            <div class="avatar-placeholder">
              {{ getInitials(results.student.name) }}
            </div>
            <div class="avatar-decoration"></div>
          </div>
          
          <div class="student-info">
            <h1 class="student-name">{{ results.student.name }}</h1>
            <div class="student-subtitle">{{ results.student.school }}</div>
            <div class="student-subtitle">{{ results.student.class }} <template v-if="results.student.paralel"> ( {{ results.student.paralel }} )</template></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rest of the template remains unchanged -->
    <div class="card programs-card">
      <!-- Bagian Priority Program -->
      <div class="program-section">
        <h3 class="card-title">PRIORITY PROGRAM</h3>
        <div class="program-item priority">
          <svg class="program-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></svg>
          <span>{{ results.priority_program }}</span>
        </div>
      </div>

      <div class="program-section">
        <h3 class="card-title recommended-title">RECOMMENDED PROGRAMS</h3>
        <ul class="recommended-list">
          <li 
            v-for="program in results.recommended_programs" 
            :key="program" 
            class="program-item"
          >
            <svg class="program-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>
            <span>{{ program }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Bagian Info Card (Disclaimer) -->
    <div class="info-card">
      <div class="info-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"/>
        </svg>
      </div>
      <div class="info-text">
        <p>
          Ini adalah hasil dari assessmen yang kamu kerjakan. Gunakan hasil ini sebagai alat bantu eksplorasi memilih program kuliah, bukan sebagai penentu akhir.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  results: {
    type: Object,
    required: true
  }
});

function getInitials(name) {
  return name.split(' ').map(n => n[0]).join('').toUpperCase();
}
</script>

<style scoped>
.results-container {
  width: 100%;
  max-width: 480px;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  animation: fade-in 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  font-family: 'Epilogue', sans-serif;
  background-color: transparent;
}

/* Enhanced Student Header Styles */
.student-header {
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.1);
  border: 1px solid #eef2f7;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
  background: linear-gradient(135deg, #4361ee, #3a0ca3);
  z-index: -1;
  clip-path: ellipse(100% 80% at 50% 0%);
}

.header-content {
  padding: 1.5rem 1.5rem 0;
  position: relative;
}

.student-badge {
  position: relative;
  display: inline-block;
  background: white;
  color: #3a0ca3;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 15px -5px rgba(0, 0, 0, 0.1);
}

.badge-decoration {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 10px;
  height: 10px;
  background: #ff9e00;
  border-radius: 50%;
  border: 2px solid white;
}

.student-profile {
  display: flex;
  align-items: flex-start;
  gap: 1.2rem;
  margin-bottom: 1.2rem;
}

.avatar-container {
  position: relative;
  flex-shrink: 0;
}

.avatar-placeholder {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffffff, #f0f4ff);
  color: #3a0ca3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.5rem;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
}

.avatar-decoration {
  position: absolute;
  bottom: -12px;
  right: -5px;
  width: 30px;
  height: 30px;
  background: #ff9e00;
  border-radius: 50%;
  z-index: 0;
}

.student-info {
  flex-grow: 1;
}

.student-name {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1a2e45;
  margin: 0 0 0.2rem 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.student-subtitle {
  font-size: 0.75rem;
  font-weight: 600;
  color: #3a0ca3;
  margin-bottom: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.student-meta {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  background: #f8fafc;
  padding: 0.8rem;
  border-radius: 12px;
  margin-top: 0.5rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: #5a6a7b;
}

.meta-icon {
  width: 14px;
  height: 14px;
  fill: #7d95b0;
}

.student-traits {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  padding-top: 0.8rem;
  border-top: 1px dashed #e2e8f0;
}

.trait-pill {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 0.4rem 0.9rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #3a0ca3;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  box-shadow: 0 2px 5px -3px rgba(0, 0, 0, 0.1);
}

.trait-icon {
  width: 12px;
  height: 12px;
  fill: #3a0ca3;
  opacity: 0.8;
}

/* Rest of the styles remain exactly the same */
.card {
  width: 100%;
  background: linear-gradient(145deg, #1e3a5f, #0d2137);
  color: white;
  padding: 1.25rem;
  border-radius: 20px;
  box-shadow: 0 10px 25px -10px rgba(29, 58, 95, 0.6);
}

.program-section {
  margin-bottom: 1rem;
}
.program-section:last-child {
  margin-bottom: 0;
}

.card-title {
  font-family: 'Epilogue', sans-serif;
  font-weight: 900;
  font-size: 0.8rem;
  text-align: left;
  margin-bottom: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.5);
}
.card-title.recommended-title {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;
}

.recommended-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.program-item {
  background-color: rgba(255, 255, 255, 0.07);
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1rem;
  border-radius: 14px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.program-item:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.program-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  fill: #4dabf7;
}

.program-item.priority {
  background: white;
  color: #0d2137;
  font-size: 1rem;
  font-weight: 700;
  padding: 1rem;
}
.program-item.priority .program-icon {
  fill: #ffc107;
}

.info-card {
  background-color: white;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border-radius: 20px;
  margin-top: 10px;
}
.info-icon {
  flex-shrink: 0;
  margin-top: 2px;
}
.info-icon svg {
  width: 18px;
  height: 18px;
  fill: #7d95b0;
}
.info-text p {
  font-size: 0.75rem;
  color: #5a6a7b;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 480px) {
  .student-meta {
    flex-direction: column;
  }
  
  .student-name {
    font-size: 1.4rem;
  }
  
  .avatar-placeholder {
    width: 60px;
    height: 60px;
    font-size: 1.3rem;
  }
}
</style>